// คู่มือการใช้งานเมนูผู้ดูแลระบบส่วนกลาง (หน้า /admin/home_menu) แยกตามแท็บ
// แก้ไขเนื้อหาที่ไฟล์นี้ไฟล์เดียวเมื่อกระบวนงานเปลี่ยน — AdminMenuGuide.vue เป็นตัวแสดงผลอย่างเดียว
//
// โครงสร้างต่อแท็บ (key = tab.id ใน home_menu.vue):
//   title, purpose       ความสำคัญของเมนู
//   cycle                ช่วงเวลา/รอบการทำงานโดยประมาณ
//   flows[]              กระบวนงาน (1 แท็บมีได้หลายกระบวนงาน)
//     steps[]            { actor, title, detail, to?, tip? }
//                        actor: central (ส่วนกลาง) | college (สถานศึกษา) | vecpro (สอจ./สถาบัน)
//                               | person (บุคลากร/ผู้สมัคร) | system (ระบบประมวลผล)
//   checklist[]          สิ่งที่ต้องตรวจก่อน/หลังดำเนินการ
//   cautions[]           ข้อควรระวัง/ข้อผิดพลาดที่พบบ่อย
//   faq[]                { q, a }

export const ACTORS = {
  central: { label: "ส่วนกลาง", color: "primary", icon: "mdi-shield-account" },
  college: { label: "สถานศึกษา", color: "teal", icon: "mdi-school" },
  vecpro: { label: "สอจ./สถาบัน", color: "deep-purple", icon: "mdi-office-building" },
  person: { label: "บุคลากร/ผู้สมัคร", color: "orange darken-2", icon: "mdi-account" },
  system: { label: "ระบบ", color: "blue-grey", icon: "mdi-cog" }
};

// ขั้นตอนร่วมที่ใช้ในทุกกระบวนงานที่มี "กำหนดการ"
const PERIOD_RULE =
  "กำหนดการคือสวิตช์เปิด/ปิดสิทธิ์บันทึกข้อมูลของผู้ใช้ฝั่งนั้น — เปิดเมื่อเริ่มกิจกรรม และต้องปิดเมื่อสิ้นสุด มิฉะนั้นผู้ใช้ยังแก้ไขข้อมูลได้ (ศูนย์แจ้งเตือนจะขึ้น “เลยกำหนดแต่ยังเปิด”)";

export const ADMIN_MENU_GUIDE = {
  // ------------------------------------------------------------------
  basic: {
    title: "ข้อมูลพื้นฐาน",
    purpose:
      "ข้อมูลตั้งต้นที่ทุกระบบย่อยใช้ร่วมกัน ได้แก่ สถานศึกษา บัญชีผู้ใช้งาน ข้อมูลข้าราชการครูและบุคลากร และสาขาวิชา — ถ้าข้อมูลส่วนนี้ผิด การย้าย อัตรากำลัง และการประเมินจะผิดตามทั้งหมด",
    cycle: "ทำต่อเนื่องตลอดปี · ทบทวนใหญ่ก่อนเปิดรอบการย้าย/อัตรากำลังทุกครั้ง",
    flows: [
      {
        name: "ดูแลข้อมูลข้าราชการครูและบุคลากร (ข้อมูลหลัก)",
        steps: [
          {
            actor: "central",
            title: "นำเข้า/ปรับปรุงข้อมูลหลัก",
            detail: "ตรวจรายชื่อ ตำแหน่ง เลขที่ตำแหน่ง วิทยฐานะ และสังกัด ให้ตรงกับทะเบียนประวัติ",
            to: "/admin/personnel_tem"
          },
          {
            actor: "college",
            title: "สถานศึกษาแจ้งปรับปรุงข้อมูลบุคลากร",
            detail: "สถานศึกษาส่งคำขอแก้ไขข้อมูลที่ไม่ถูกต้องเข้ามา (สถานะ “รอดำเนินการ”)"
          },
          {
            actor: "central",
            title: "ตรวจและแก้ไขตามคำขอ",
            detail: "เปิดรายการที่สถานศึกษาแจ้ง ตรวจหลักฐาน แก้ข้อมูล แล้วเปลี่ยนสถานะเป็นปรับปรุงแล้ว",
            to: "/admin/Dashboard?tab=notify",
            tip: "จำนวนคำขอค้างแสดงในศูนย์แจ้งเตือนด้านบน"
          },
          {
            actor: "college",
            title: "สถานศึกษาขอรับข้อมูลบุคคลเข้าสังกัด",
            detail: "กรณีย้าย/บรรจุเข้าใหม่ สถานศึกษาปลายทางขอรับข้อมูลบุคคลจากต้นสังกัดเดิม"
          },
          {
            actor: "central",
            title: "อนุมัติการโอนข้อมูลเข้าสังกัด",
            detail: "ตรวจคำสั่ง/วันที่มีผล แล้วอนุมัติ ข้อมูลจะย้ายไปอยู่ภายใต้สถานศึกษาใหม่",
            to: "/admin/collegepersonnelreq"
          },
          {
            actor: "central",
            title: "ข้อมูลประกอบ",
            detail: "คุณวุฒิ ประสบการณ์ ประวัติรับราชการ ผลงาน/รางวัล ใช้เป็นคะแนนประกอบการย้ายและการคัดเลือก",
            to: "/admin/personnel_education"
          }
        ]
      },
      {
        name: "บัญชีผู้ใช้งานและสิทธิ์",
        steps: [
          {
            actor: "central",
            title: "บัญชีสถานศึกษา/สอจ./สถาบัน/Admin",
            detail: "สร้าง แก้ไข ระงับบัญชีหน่วยงาน และรีเซ็ตรหัสผ่านเมื่อได้รับการร้องขอที่ยืนยันตัวตนแล้ว",
            to: "/admin/user"
          },
          {
            actor: "central",
            title: "บัญชีข้าราชการครูและบุคลากร",
            detail: "ตรวจสถานะการเข้าใช้งานของบุคลากรรายบุคคล",
            to: "/admin/personnel"
          },
          {
            actor: "central",
            title: "มอบหมายภารกิจให้ Admin (เฉพาะ SuperAdmin)",
            detail:
              "กำหนดว่า Admin แต่ละคนดูแลภารกิจใด (อัตรากำลัง/ย้ายครู/ย้ายผู้บริหาร/พนักงานราชการ/คัดเลือก/ครูผู้ช่วย) — แท็บในหน้านี้จะแสดงตามภารกิจที่ได้รับ",
            to: "/admin/userAdmin",
            tip: "เมื่อมีการเปลี่ยนผู้รับผิดชอบ ให้ถอนสิทธิ์คนเดิมทันที"
          }
        ]
      },
      {
        name: "ข้อมูลสถานศึกษาและสาขาวิชา",
        steps: [
          {
            actor: "central",
            title: "ประเภทสถานศึกษา / สถาบัน / สถานศึกษา",
            detail: "ใช้กำหนดสังกัด การจัดกลุ่มรายงาน และกลุ่มการพิจารณาย้าย",
            to: "/admin/college"
          },
          {
            actor: "central",
            title: "สาขาวิชาเอก / สาขางาน / ประเภทวิชา",
            detail: "รหัสสาขาใช้จับคู่ “ตำแหน่งว่างที่สถานศึกษาต้องการ” กับ “สาขาของผู้ขอย้าย” — ต้องครบและไม่ซ้ำ",
            to: "/admin/branch"
          }
        ]
      }
    ],
    checklist: [
      "ก่อนเปิดรอบย้าย: ตรวจว่าข้อมูลตำแหน่ง/เลขที่ตำแหน่ง/สังกัดเป็นปัจจุบัน",
      "คำขอแก้ไขข้อมูลจากสถานศึกษาไม่ค้างเกิน 7 วัน",
      "บัญชี Admin ที่ย้าย/พ้นหน้าที่ถูกถอนสิทธิ์แล้ว",
      "สาขาวิชาใหม่ถูกเพิ่มก่อนสถานศึกษาแจ้งตำแหน่งว่าง"
    ],
    cautions: [
      "ห้ามแก้เลขบัตรประชาชนโดยไม่มีเอกสารยืนยัน — เป็นคีย์เชื่อมข้อมูลทุกระบบ",
      "การลบบุคลากรกระทบประวัติการย้าย/การประเมินย้อนหลัง ให้ใช้การเปลี่ยนสถานะแทนการลบ",
      "การรีเซ็ตรหัสผ่านต้องยืนยันตัวตนผู้ร้องขอทุกครั้ง (เหตุการณ์ ThaiCERT)"
    ],
    faq: [
      {
        q: "สถานศึกษาแจ้งว่าไม่เห็นบุคลากรที่ย้ายเข้ามา?",
        a: "ตรวจที่เมนู “ข้อมูลขอรับข้อมูลบุคคล” ว่าคำขอได้รับอนุมัติแล้วหรือยัง"
      },
      {
        q: "Admin ใหม่ไม่เห็นแท็บที่ต้องใช้?",
        a: "SuperAdmin ต้องเปิดภารกิจนั้นให้ที่เมนูจัดการผู้ใช้ Admin แล้วให้ออกจากระบบและเข้าใหม่"
      }
    ]
  },

  // ------------------------------------------------------------------
  manpower: {
    title: "งานอัตรากำลัง",
    purpose:
      "รวบรวมข้อมูลบุคลากรและจำนวนนักเรียนของทุกสถานศึกษา เพื่อคำนวณอัตรากำลังที่ควรมี เทียบกับที่มีจริง และบริหารเลขที่ตำแหน่งว่าง (จ.18) ซึ่งเป็นฐานของการย้ายและการบรรจุ",
    cycle: "รายงานอัตรากำลังปีละ 1 ครั้ง · สำรวจสาขาวิชาตำแหน่งว่างก่อนรอบย้าย/บรรจุ",
    flows: [
      {
        name: "รายงานอัตรากำลังประจำปี",
        steps: [
          {
            actor: "central",
            title: "เปิดกำหนดการรายงานอัตรากำลัง",
            detail: "กำหนดปี/รอบ วันเริ่ม–สิ้นสุด แล้วเปิดสิทธิ์ให้สถานศึกษาบันทึก",
            to: "/admin/sys_config_collegemanpower",
            tip: PERIOD_RULE
          },
          {
            actor: "college",
            title: "สถานศึกษาปรับปรุงข้อมูลบุคลากร",
            detail: "บันทึกบุคลากรทุกประเภท (ข้าราชการ พนักงานราชการ ลูกจ้าง) และจำนวนนักเรียน ศธ.02"
          },
          {
            actor: "central",
            title: "ติดตามและตรวจสอบข้อมูล",
            detail: "ดูรายสถานศึกษาว่าส่งครบหรือยัง ตรวจข้อมูลผิดปกติ (ชื่อซ้ำ เลขบัตรผิด)",
            to: "/admin/personnel_etc"
          },
          {
            actor: "central",
            title: "จำนวนนักเรียน ศธ.02",
            detail: "ตรวจจำนวนนักเรียนรายสาขา ซึ่งเป็นตัวตั้งของสูตรคำนวณ",
            to: "/admin/power_rate/rate_work_college"
          },
          {
            actor: "system",
            title: "คำนวณอัตรากำลัง",
            detail: "ประมวลผลตามเกณฑ์ ได้อัตราที่ควรมี/ขาด/เกิน รายสถานศึกษาและรายสาขา",
            to: "/admin/power_rate/rate_workforce_pro"
          },
          {
            actor: "central",
            title: "ปิดกำหนดการ และออกรายงานประจำปี",
            detail: "ปิดสิทธิ์บันทึก แล้วใช้รายงานประกอบการจัดสรรอัตรา",
            to: "/admin/rate_work_g"
          }
        ]
      },
      {
        name: "สำรวจสาขาวิชาของเลขที่ตำแหน่งว่าง",
        steps: [
          {
            actor: "central",
            title: "จัดการเลขที่ตำแหน่งว่าง (จ.18)",
            detail: "ปรับสถานะตำแหน่งว่างให้เป็นปัจจุบัน ก่อนให้สถานศึกษาระบุสาขา",
            to: "/admin/jor18"
          },
          {
            actor: "central",
            title: "เปิดกำหนดการแจ้งสาขาวิชาตำแหน่งว่าง",
            to: "/admin/sys_config_collegemanpower_report",
            tip: PERIOD_RULE
          },
          {
            actor: "college",
            title: "สถานศึกษาระบุสาขาวิชาที่ต้องการ + แนบไฟล์ยืนยัน",
            detail: "ระบุสาขาต่อเลขที่ตำแหน่ง แล้วแนบหนังสือลงนาม"
          },
          {
            actor: "college",
            title: "(ถ้ามี) สถานศึกษาขอยกเลิกไฟล์เพื่อแก้ไข",
            detail: "สถานะจะเป็น “ขอยกเลิก” และแสดงในศูนย์แจ้งเตือน"
          },
          {
            actor: "central",
            title: "ตรวจสถานะการรายงาน / อนุมัติคำขอยกเลิก",
            detail: "ลบไฟล์เดิมเพื่อให้สถานศึกษาส่งใหม่ หรือปฏิเสธคำขอ",
            to: "/admin/jor18_report"
          },
          {
            actor: "central",
            title: "ตรวจรายละเอียดการรายงาน (เลขที่ตำแหน่ง)",
            detail: "ข้อมูลนี้จะถูกใช้เป็นตำแหน่งว่างรองรับการย้ายครู",
            to: "/admin/college_manpower"
          }
        ]
      }
    ],
    checklist: [
      "สถานศึกษาส่งข้อมูลครบทุกแห่งก่อนคำนวณ",
      "ไม่มีคำขอยกเลิกไฟล์ค้าง ก่อนนำตำแหน่งว่างไปใช้ในการย้าย",
      "ปิดกำหนดการหลังวันสิ้นสุดทุกครั้ง"
    ],
    cautions: [
      "เมนู “ข้อมูลอัตรากำลัง จ.18” ใน “พิจารณาย้าย” และ “จัดการเลขที่ตำแหน่งว่าง” คือข้อมูลชุดเดียวกัน — แก้ที่หนึ่งมีผลทั้งสองที่",
      "การคำนวณใหม่ทับผลเดิม ให้ส่งออกรายงานเก็บไว้ก่อนคำนวณซ้ำ"
    ],
    faq: [
      {
        q: "ยอดสถานศึกษาที่มีข้อมูลบน Dashboard ไม่ครบ 100%?",
        a: "แปลว่ายังมีสถานศึกษาที่ไม่บันทึกข้อมูลบุคลากรเลย ให้ติดตามจากเมนูอัตรากำลังสถานศึกษา"
      }
    ]
  },

  // ------------------------------------------------------------------
  transfer: {
    title: "ย้ายข้าราชการครู / ผู้บริหาร",
    purpose:
      "บริหารการย้ายประจำปีตั้งแต่เปิดรับคำร้อง รวบรวม พิจารณา ประมวลผลจับคู่กับตำแหน่งว่าง ออกคำสั่ง จนถึงรายงานตัว ณ สถานศึกษาปลายทาง — เป็นกระบวนงานที่มีผลทางกฎหมายต่อบุคคล ต้องถูกต้องและตรวจสอบย้อนหลังได้",
    cycle: "ย้ายครู ปีละ 1–2 รอบ · ย้ายผู้บริหาร ปีละ 1 รอบ · 38 ค.(2) ตามประกาศ",
    flows: [
      {
        name: "ย้ายข้าราชการครู (สายการสอน)",
        steps: [
          {
            actor: "central",
            title: "1. ตั้งกำหนดการย้ายครู",
            detail: "ปี/รอบ วันยื่น วันสิ้นสุดแนบไฟล์ วันตัดอายุราชการ และกรณีปกติ/พิเศษ",
            to: "/admin/timelines/transfer_teachers",
            tip: PERIOD_RULE
          },
          {
            actor: "college",
            title: "2. สถานศึกษาแจ้งเงื่อนไขสาขาวิชาที่รับย้าย",
            detail: "ใช้ตำแหน่งว่างจากงานอัตรากำลัง",
            to: "/admin/conditions_transfer"
          },
          {
            actor: "person",
            title: "3. ครูยื่นคำร้องขอย้ายออนไลน์",
            detail: "เลือกสถานศึกษาปลายทางตามลำดับ แนบเอกสาร"
          },
          {
            actor: "college",
            title: "4. ต้นสังกัดรวบรวมและรับรองคำร้อง",
            detail: "ตรวจเอกสาร ให้ความเห็น แนบไฟล์เสนอย้าย (ขอยกเลิกไฟล์ได้ ⇒ แจ้งเตือนส่วนกลาง)"
          },
          {
            actor: "vecpro",
            title: "5. สอจ. พิจารณาย้าย (ย้ายออก)",
            detail: "ให้ความเห็นระดับจังหวัด"
          },
          {
            actor: "central",
            title: "6. ตรวจคำร้องและคะแนนประกอบการพิจารณา",
            detail: "ตรวจความครบถ้วน จัดการคำขอยกเลิกไฟล์ของสถานศึกษา/สอจ.",
            to: "/admin/transference_personnel"
          },
          {
            actor: "system",
            title: "7. ประมวลผลการย้าย",
            detail:
              "แบบ 1 จับคู่ตามลำดับคะแนน · แบบ 2 ตามตำแหน่งว่าง · แบบ 3 สับเปลี่ยนปกติ · แบบ 4 สับเปลี่ยน — เลือกตามมติคณะกรรมการ",
            to: "/admin/process_transfer"
          },
          {
            actor: "college",
            title: "8. วิทยาลัยปลายทางรับฟังความคิดเห็น",
            detail: "ยืนยันรับ/ไม่รับ ตามผลประมวล"
          },
          {
            actor: "central",
            title: "9. สรุปผลและออกคำสั่ง",
            detail: "ตรวจสรุปผล แล้วส่งออกเอกสารประกอบการพิจารณา/คำสั่ง",
            to: "/admin/conditons_transfer_success"
          },
          {
            actor: "college",
            title: "10. รายงานตัว ณ สถานศึกษาปลายทาง",
            detail: "ส่วนกลางติดตามจนครบ และจัดการคำขอยกเลิกการรายงานตัว",
            to: "/admin/conditons_transfer_success_reportmv"
          }
        ]
      },
      {
        name: "ย้ายผู้บริหาร (ผอ./รอง ผอ.)",
        steps: [
          {
            actor: "central",
            title: "1. ตั้งกำหนดการ ผอ. และ รอง ผอ.",
            detail: "กำหนดการสองตำแหน่งแยกกัน",
            to: "/admin/timelines/transfer_directors",
            tip: PERIOD_RULE
          },
          {
            actor: "person",
            title: "2. ผู้บริหารยื่นคำร้องขอย้าย",
            detail: "กรณีปกติ / พิเศษ / พัฒนาคุณภาพ (ผอ.)"
          },
          {
            actor: "vecpro",
            title: "3. สอจ. พิจารณาย้ายผู้บริหาร"
          },
          {
            actor: "central",
            title: "4. ตรวจสายงานบริหารสถานศึกษาและข้อมูลประกอบ",
            to: "/admin/transference_manage_main"
          },
          {
            actor: "system",
            title: "5. ประมวลผลย้าย",
            detail: "อัตโนมัติ หรือแบบ 1 / แบบ 2 (ตามวิทยาลัยปลายทาง)",
            to: "/admin/transference_manage_auto_match"
          },
          {
            actor: "college",
            title: "6. วิทยาลัยปลายทางรับฟังความคิดเห็น"
          },
          {
            actor: "central",
            title: "7. บทสรุปผลการย้าย / ออกคำสั่ง",
            to: "/admin/transference_manage_report"
          },
          {
            actor: "college",
            title: "8. ติดตามการรายงานตัว",
            to: "/admin/conditons_transfer_success_reportmv_director"
          }
        ]
      },
      {
        name: "ย้ายบุคลากรทางการศึกษาอื่น มาตรา 38 ค.(2)",
        steps: [
          { actor: "central", title: "ตั้งกำหนดการ 38 ค.(2)", to: "/admin/timelines/transfer_38", tip: PERIOD_RULE },
          { actor: "central", title: "กำหนดตำแหน่งว่าง", to: "/admin/man_power_38" },
          { actor: "college", title: "ต้นสังกัดรวบรวมคำร้องขอย้าย" },
          { actor: "central", title: "พิจารณา/ประมวลผลย้าย 38 ค.(2)", to: "/admin/transference_personnel_38" },
          { actor: "college", title: "วิทยาลัยปลายทางรับรายงานตัว" }
        ]
      }
    ],
    checklist: [
      "ก่อนเปิดรอบ: ตำแหน่งว่างและเงื่อนไขสาขาของสถานศึกษาครบ",
      "ก่อนประมวลผล: ไม่มีคำขอยกเลิกไฟล์ค้าง และปิดรับคำร้องแล้ว",
      "หลังประมวลผล: ส่งออกผลเก็บไว้ก่อนประมวลผลซ้ำ",
      "หลังออกคำสั่ง: ติดตามรายงานตัวครบทุกราย แล้วปรับข้อมูลสังกัดในข้อมูลหลัก"
    ],
    cautions: [
      "ห้ามประมวลผลขณะยังเปิดรับคำร้อง — ข้อมูลเปลี่ยนระหว่างประมวลผล",
      "“ยกเลิกกำหนดการระบบทั้งหมด” (ปุ่มปฏิทินด้านบน) ปิดทุกกำหนดการทุกภารกิจพร้อมกัน ใช้เฉพาะกรณีฉุกเฉิน",
      "คะแนนประกอบการพิจารณามาจากข้อมูลพื้นฐาน (อายุราชการ ผลงาน) — ถ้าข้อมูลพื้นฐานผิด คะแนนผิด"
    ],
    faq: [
      {
        q: "สถานศึกษาแนบไฟล์ผิด ต้องทำอย่างไร?",
        a: "ให้สถานศึกษากด “ขอยกเลิกไฟล์” แล้วส่วนกลางอนุมัติในหน้าย้ายครู [ประมวลผลแบบ 1] ระบบจะลบไฟล์ให้แนบใหม่"
      },
      {
        q: "ครูยื่นย้ายไม่ได้ทั้งที่อยู่ในช่วงเวลา?",
        a: "ตรวจกำหนดการว่าเปิดสถานะอยู่หรือไม่ (ศูนย์แจ้งเตือนจะแสดง “ถึงกำหนดแต่ยังปิด”)"
      }
    ]
  },

  // ------------------------------------------------------------------
  govem: {
    title: "พนักงานราชการ",
    purpose:
      "บริหารกรอบอัตรากำลังพนักงานราชการ การประเมินผลการปฏิบัติงาน ค่าตอบแทน/การเบิกจ่าย และการย้ายพนักงานราชการ",
    cycle: "รายงานกรอบปีละ 1 ครั้ง · ประเมินผลตามรอบ · ค่าตอบแทนรายปีงบประมาณ · ย้ายตามประกาศ",
    flows: [
      {
        name: "กรอบอัตรากำลังและการประเมิน",
        steps: [
          {
            actor: "central",
            title: "1. เปิดกำหนดการรายงานกรอบอัตรากำลัง",
            to: "/admin/gov_em/period_mgovem",
            tip: PERIOD_RULE
          },
          {
            actor: "college",
            title: "2. สถานศึกษารายงานกรอบ (ผู้ครองตำแหน่ง/ตำแหน่งว่าง/สัญญาจ้าง)"
          },
          {
            actor: "central",
            title: "3. ตรวจการรายงานของสถานศึกษา",
            to: "/admin/gov_em/Governmentemployeereportadmin"
          },
          {
            actor: "central",
            title: "4. กรอบอัตรากำลังส่วนกลาง / ข้อมูลกรอบ",
            detail: "ปรับปรุงกรอบให้ตรงกับที่ได้รับจัดสรร",
            to: "/admin/gov_em/government_employee"
          },
          {
            actor: "central",
            title: "5. การประเมินผลการปฏิบัติงาน",
            to: "/admin/gov_em_vec/assessment_govem"
          },
          {
            actor: "central",
            title: "6. รายงานกรอบ / รายงานการเบิกจ่าย สนผ.",
            to: "/admin/gov_em/government_employee_report"
          },
          {
            actor: "central",
            title: "7. ค่าตอบแทนประจำปี",
            to: "/admin/gov_em/salary_gov_2568"
          }
        ]
      },
      {
        name: "ย้ายพนักงานราชการ",
        steps: [
          {
            actor: "central",
            title: "1. ตั้งกำหนดการย้ายพนักงานราชการ",
            to: "/admin/timelines/transfer_govem",
            tip: PERIOD_RULE
          },
          {
            actor: "college",
            title: "2. สถานศึกษาสำรวจตำแหน่งว่าง + กำหนดสาขา",
            detail: "แนบไฟล์ยืนยัน (ขอยกเลิกไฟล์ได้)",
            to: "/admin/conditions_branch_govem"
          },
          { actor: "person", title: "3. พนักงานราชการยื่นคำร้องขอย้าย" },
          { actor: "college", title: "4. ต้นสังกัดรวบรวมคำร้อง" },
          {
            actor: "central",
            title: "5. ตรวจคำร้อง / ข้อมูลประกอบการพิจารณา",
            to: "/admin/gov_em/transference_location_detail"
          },
          {
            actor: "system",
            title: "6. ประมวลผลการย้าย (แบบ 1–4)",
            to: "/admin/gov_em/transference_personnel"
          },
          { actor: "central", title: "7. สรุปผลการย้าย / คำสั่งย้าย", to: "/admin/gov_em/conditons_transfer_success" },
          {
            actor: "college",
            title: "8. รายงานตัว ณ ปลายทาง",
            to: "/admin/gov_em/conditons_transfer_success_reportmv"
          }
        ]
      }
    ],
    checklist: [
      "สัญญาจ้างที่ใกล้หมด/หมดแล้วได้รับการปรับปรุง",
      "ตำแหน่งว่างของสถานศึกษาตรงกับกรอบที่ได้รับจัดสรร",
      "บันทึกประวัติการลาออก/พ้นสภาพก่อนนำตำแหน่งไปเปิดย้าย"
    ],
    cautions: [
      "พนักงานราชการกับข้าราชการครูใช้ตารางคำร้องย้ายร่วมกัน แยกด้วยปี/รอบของกำหนดการ — อย่าตั้งปี/รอบซ้ำกับการย้ายครู",
      "พนักงานราชการไม่ใช่ข้าราชการ อย่าใช้เกณฑ์/สูตรของข้าราชการครูปะปน"
    ],
    faq: [
      {
        q: "ต้องการดูผู้ที่ลาออกย้อนหลัง?",
        a: "ใช้เมนู “ประวัติการลาออก” ในกลุ่มประวัติพนักงานราชการ"
      }
    ]
  },

  // ------------------------------------------------------------------
  selection: {
    title: "คัดเลือกสายบริหาร / ศึกษานิเทศก์",
    purpose:
      "จัดการคัดเลือกเพื่อบรรจุแต่งตั้ง รอง ผอ. / ผอ. / ศึกษานิเทศก์ ตั้งแต่รับสมัคร ตรวจคุณสมบัติ ประเมินภาค ก–ค ประกาศผล จนเลือกสถานศึกษาและรายงานตัว",
    cycle: "ตามประกาศรับสมัครแต่ละครั้ง (ไม่แน่นอน) — ทบทวนคู่มือนี้ทุกครั้งก่อนเปิดรับสมัคร",
    flows: [
      {
        name: "คัดเลือกรองผู้อำนวยการ",
        steps: [
          { actor: "central", title: "1. ตั้งกำหนดการประกาศสมัคร", to: "/admin/timelines/examination_deputyDirector", tip: PERIOD_RULE },
          { actor: "person", title: "2. ผู้สมัครยื่นใบสมัคร + เอกสาร" },
          { actor: "vecpro", title: "3. สอจ. ตรวจสอบคุณสมบัติ" },
          { actor: "central", title: "4. ตรวจผู้สมัคร / ประกาศรายชื่อผู้มีสิทธิ์", to: "/admin/sedirector_app" },
          { actor: "college", title: "5. วิทยาลัยต้นสังกัดรายงานผล ภาค ก", to: "/admin/sedirector_assessment/sedirector_app_a" },
          { actor: "vecpro", title: "6. สอจ. รายงานผล ภาค ข", to: "/admin/sedirector_assessment/sedirector_app_b" },
          { actor: "central", title: "7. ประเมินภาค ค (สัมภาษณ์) และประกาศผล", to: "/admin/sedirector_assessment/sedirector_app_notice" },
          { actor: "central", title: "8. กำหนดตำแหน่งว่างสถานศึกษา", to: "/admin/sedirector_assessment/director_college_manpower" },
          { actor: "person", title: "9. ผู้ผ่านการคัดเลือกรายงานตัวเลือกสถานศึกษา", to: "/admin/sedirector_assessment/sedirector_app_choose" },
          { actor: "college", title: "10. วิทยาลัยปลายทางรับรายงานตัว" }
        ]
      },
      {
        name: "คัดเลือกผู้อำนวยการ",
        steps: [
          { actor: "central", title: "1. ตั้งกำหนดการประกาศสมัคร", to: "/admin/timelines/examination_Director", tip: PERIOD_RULE },
          { actor: "person", title: "2. ผู้สมัครยื่นใบสมัคร" },
          { actor: "vecpro", title: "3. สอจ. ตรวจสอบคุณสมบัติ" },
          { actor: "central", title: "4. ประกาศรายชื่อผู้มีสิทธิ์ / ภาค ก", to: "/admin/director_app" },
          { actor: "vecpro", title: "5. สอจ./สถาบัน/ศูนย์ส่งเสริม ประเมิน ภาค ข", to: "/admin/director_assessment/director_app_b" },
          { actor: "central", title: "6. ภาค ค และประกาศผลการคัดเลือก", to: "/admin/director_assessment/director_app_notice" },
          { actor: "person", title: "7. รายงานตัวเลือกสถานศึกษา", to: "/admin/director_assessment/director_app_choose" },
          { actor: "college", title: "8. วิทยาลัยปลายทางรับรายงานตัว", to: "/admin/director_assessment/director_app_report_college" }
        ]
      },
      {
        name: "คัดเลือกศึกษานิเทศก์",
        steps: [
          { actor: "central", title: "1. ตั้งกำหนดการประกาศสมัคร", to: "/admin/timelines/examination_Supervisor", tip: PERIOD_RULE },
          { actor: "person", title: "2. ผู้สมัครยื่นใบสมัคร", to: "/admin/supervisor_app" },
          { actor: "central", title: "3. ประกาศรายชื่อผู้ผ่านการคัดเลือก", detail: "หน้าจอนี้ยังไม่เปิดใช้งานในระบบ — ดำเนินการนอกระบบไปก่อน" },
          { actor: "central", title: "4. รายงานตัว / บรรจุแต่งตั้ง", detail: "หน้าจอนี้ยังไม่เปิดใช้งานในระบบ — ดำเนินการนอกระบบไปก่อน" }
        ]
      }
    ],
    checklist: [
      "ประกาศรับสมัครกำหนดคุณสมบัติ/วันตัดอายุ ตรงกับกำหนดการในระบบ",
      "คำขอยกเลิกไฟล์ใบสมัคร (สอจ.) ได้รับการดำเนินการก่อนประกาศรายชื่อ",
      "คะแนนแต่ละภาคครบทุกคนก่อนประกาศผล"
    ],
    cautions: [
      "ข้อมูลผู้สมัครและคะแนนเป็นข้อมูลอ่อนไหว — ส่งออกเท่าที่จำเป็นและไม่ส่งต่อทางช่องทางไม่เป็นทางการ",
      "ใบสมัคร ผอ. และ รอง ผอ. เก็บในตารางเดียวกัน แยกด้วยประเภท — ตรวจให้แน่ใจว่าอยู่ในหน้าที่ถูกต้อง"
    ],
    faq: [
      {
        q: "ผู้สมัครแนบไฟล์ผิด?",
        a: "ให้ สอจ. แจ้งขอยกเลิกไฟล์ ส่วนกลางดำเนินการในหน้าผู้สมัคร (ศูนย์แจ้งเตือนจะแสดงจำนวน)"
      }
    ]
  },

  // ------------------------------------------------------------------
  assistant: {
    title: "ครูผู้ช่วย",
    purpose:
      "ดูแลครูผู้ช่วยตั้งแต่เรียกรายงานตัว เลือกสถานศึกษา รายงานตัว ณ สถานศึกษา ไปจนถึงการเตรียมความพร้อมและพัฒนาอย่างเข้ม (ประเมิน 2 ปี) เพื่อแต่งตั้งเป็นครู",
    cycle: "เรียกรายงานตัวตามรอบบรรจุ · ประเมินต่อเนื่อง 2 ปีต่อราย",
    flows: [
      {
        name: "เรียกรายงานตัวครูผู้ช่วย",
        steps: [
          { actor: "central", title: "1. ตั้งกำหนดการรายงานตัว", to: "/admin/timelines/report_assistantteacher", tip: PERIOD_RULE },
          { actor: "central", title: "2. นำเข้ารายชื่อผู้ได้รับเรียกรายงานตัว (ต่อรอบ)", to: "/admin/assistant_teacher_report/manage_assistant_teacher" },
          { actor: "central", title: "3. เตรียมเลขที่ตำแหน่งว่างของวิทยาลัย", to: "/admin/assistant_teacher_report/manage_college_manpower" },
          { actor: "person", title: "4. รายงานตัวออนไลน์ / เลือกสถานศึกษา", to: "/admin/assistant_teacher_report/teacher_college_manpower_report" },
          {
            actor: "college",
            title: "5. วิทยาลัยรับรายงานตัว",
            detail: "ยืนยันการรายงานตัว หรือขอยกเลิกเมื่อข้อมูลผิดพลาด (⇒ แจ้งเตือนส่วนกลาง)"
          },
          {
            actor: "central",
            title: "6. อนุมัติการรายงานตัว / จัดการคำขอยกเลิก",
            to: "/admin/assistant_teacher_report/manage_assistant_CollegeReport"
          },
          { actor: "central", title: "7. กรณีโอนย้าย", to: "/admin/assistant_teacher_report/manage_assistant_CollegeReportTran" }
        ]
      },
      {
        name: "ประเมินการเตรียมความพร้อมและพัฒนาอย่างเข้ม",
        steps: [
          { actor: "central", title: "1. กำหนดรอบบรรจุ", to: "/admin/assistant_teacher_report/personnel_temporary_assistant_period" },
          { actor: "college", title: "2. สถานศึกษาเสนอผู้ทรงคุณวุฒิ", to: "/admin/assistant_teacher_report/assistantcommitteequalified" },
          { actor: "college", title: "3. สถานศึกษาเสนอคณะกรรมการประเมิน + แนบคำสั่ง", to: "/admin/assistant_teacher_report/manage_assistant_teacher_committee" },
          { actor: "central", title: "4. ตรวจคำสั่งแต่งตั้งกรรมการ / คำขอยกเลิกไฟล์", to: "/admin/assistantcommittee" },
          { actor: "college", title: "5. คณะกรรมการประเมินตามรอบ (รวม 4 ครั้ง / 2 ปี)" },
          { actor: "central", title: "6. ตรวจสอบผลการประเมิน", to: "/admin/assistant_teacher" },
          { actor: "central", title: "7. รายงานผลประเมิน (ครบ) เพื่อแต่งตั้งเป็นครู", to: "/admin/assistant_teacher_reports" }
        ]
      }
    ],
    checklist: [
      "เลขที่ตำแหน่งว่างพร้อมก่อนเปิดเลือกสถานศึกษา",
      "คำขอยกเลิกการรายงานตัวไม่ค้าง (ดูศูนย์แจ้งเตือน)",
      "ใบอนุญาตประกอบวิชาชีพของครูผู้ช่วยยังไม่หมดอายุ",
      "ผลการประเมินครบทุกครั้งก่อนออกรายงาน"
    ],
    cautions: [
      "รอบ/ปี 99/9999 ในข้อมูลครูผู้ช่วยเป็นรายการพิเศษ ไม่ใช่รอบจริง",
      "การอนุมัติรายงานตัวผิดคนกระทบวันบรรจุ ให้ตรวจเลขบัตรและเลขที่ตำแหน่งก่อนอนุมัติ"
    ],
    faq: [
      {
        q: "วิทยาลัยกดยืนยันรายงานตัวผิดคน?",
        a: "ให้วิทยาลัยกด “ขอยกเลิกข้อมูล” พร้อมเหตุผล แล้วส่วนกลางดำเนินการในหน้าการรายงานตัว ณ สถานศึกษา"
      }
    ]
  },

  // ------------------------------------------------------------------
  news: {
    title: "ข่าวสารและคู่มือ",
    purpose: "ช่องทางสื่อสารอย่างเป็นทางการจากส่วนกลางถึงสถานศึกษา/สอจ./บุคลากร และคลังคู่มือการใช้งาน",
    cycle: "ทุกครั้งที่เปิด/ปิดกิจกรรมหรือเปลี่ยนแปลงกระบวนงาน",
    flows: [
      {
        name: "ประชาสัมพันธ์กิจกรรม",
        steps: [
          { actor: "central", title: "1. ประกาศข่าวเมื่อเปิดกำหนดการ", detail: "ระบุช่วงเวลา กลุ่มเป้าหมาย และลิงก์คู่มือ", to: "/admin/news_s" },
          { actor: "central", title: "2. อัปโหลด/ปรับปรุงคู่มือ", detail: "แยกคู่มือตามบทบาทผู้ใช้", to: "/admin/manual_s" },
          { actor: "central", title: "3. แจ้งเตือนก่อนปิดกำหนดการ 3 วัน", detail: "ดูรายการ “ใกล้ปิด” ในศูนย์แจ้งเตือน" }
        ]
      }
    ],
    checklist: ["ข่าวที่หมดอายุถูกปิดการแสดงผล", "คู่มือเป็นเวอร์ชันล่าสุดตรงกับหน้าจอจริง"],
    cautions: ["ห้ามเผยแพร่ข้อมูลส่วนบุคคลในข่าวประชาสัมพันธ์ (PDPA)"],
    faq: []
  }
};
